import React, { useEffect, useState, useContext, useRef } from 'react';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';

/**
 * Contexts
 */
import MapContext from '../../Map/MapContext';
import { useToolsContext } from '../../../context/ToolsContext';

/**
 * Components
 */
import Tool from '../../Tool/Tool';
import { Draw } from 'ol/interaction';
import { sourceMeasure, styleFunction, modifyStyle, modify, vectorMeasure, tipPoint } from './measureFunctions';

function MeasureLineal() {
    // const [isActive, setIsActive] = useState(false);
    const { toolStates, setToolState } = useToolsContext();
    const { map } = useContext(MapContext); // instancia del mapa del contexto
    const { t } = useTranslation(); // hook para usar la función de traducción

    const drawRef = useRef(null);

    /**
     * Ensure the tool layer is above others
     */
    const ensureLayerZIndex = () => {
        if (!vectorMeasure || !map) return;
        vectorMeasure.setZIndex(999);   // Set a high z-index
        map.removeLayer(vectorMeasure); // Remove if already added
        map.addLayer(vectorMeasure);    // Re-add to ensure it's on top
    }

    function addInteraction(drawType) {
        if (!map) return;

        console.log('Interacción');

        const activeTip = t('measureTool.tooltip') || 'Click para continuar medición. Doble click o ESC para finalizar.';
        const idleTip = '';
        let tip = idleTip;

        const draw = new Draw({
            source: sourceMeasure,
            type: drawType,
            style: function (feature) {
                return styleFunction(feature, true, drawType, tip);
            },
        });

        draw.on('drawstart', function () {
            console.log('start');
            sourceMeasure.clear();
            modify.setActive(false);
            tip = activeTip;
        });

        draw.on('drawend', function () {
            console.log('end');
            modifyStyle.setGeometry(tipPoint);
            modify.setActive(true);
            map.once('pointermove', function () {
                modifyStyle.setGeometry();
            });
            tip = idleTip;
        });

        // Save the draw interaction in the ref
        drawRef.current = draw;

        // Eventos para borrar el dibujo con Esc
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                // Borrar completamente el dibujo actual
                sourceMeasure.clear();
                // Reiniciar la interacción de dibujo
                if (drawRef.current) {
                    map.removeInteraction(drawRef.current);
                    map.addInteraction(drawRef.current);
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Guardar los handlers para eliminarlos después
        drawRef.current._cleanup = () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

        modify.setActive(true);
        map.addInteraction(draw);
        ensureLayerZIndex();
    }

    function desactivarToolMeasureLineal() {
        if (!map) return; // Verificar si map está disponible

        // Remove the draw interaction
        if (drawRef.current) {
            if (drawRef.current._cleanup) drawRef.current._cleanup(); // Limpieza de event listeners
            map.removeInteraction(drawRef.current);
            drawRef.current = null;
        }

        sourceMeasure.clear();
        map.removeLayer(vectorMeasure);
    }

    function activarToolMeasureLineal() {
        if (!map) return; // Verificar si map está disponible

        addInteraction('LineString'); // LineString Polygon
        ensureLayerZIndex();
    }

    useEffect(() => {
        if (toolStates?.measureLineal?.active) {
            activarToolMeasureLineal();
        } else {
            desactivarToolMeasureLineal();
        }

        return () => {
            desactivarToolMeasureLineal();
        };
    }, [toolStates?.measureLineal?.active, map]);

    return (
        <Tool
            id="measureLineal"
            type="toggleable"
            icon='bi bi-rulers'
            label={t('Measure lineal')}
        />
    );
}

export default MeasureLineal;